import { c as _c } from "react/compiler-runtime";
import { Form, type TemplateInputProps } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import type { CustomQuestionsFormData } from '../../../types';
type TextBlockFormProps = {
  questionIndex: number;
  autocompleteItems?: TemplateInputProps['autocompleteItems'];
};
const TextBlockForm = t0 => {
  const $ = _c(16);
  const {
    questionIndex,
    autocompleteItems
  } = t0;
  const {
    t
  } = useTranslation("playbook-custom-questions");
  const t1 = `questions.${questionIndex}.content`;
  let t2;
  if ($[0] !== t) {
    t2 = t(_temp);
    $[0] = t;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t) {
    t3 = t(_temp2);
    $[2] = t;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== autocompleteItems) {
    t4 = autocompleteItems ?? {};
    $[4] = autocompleteItems;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t) {
    t5 = t(_temp3);
    $[6] = t;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t5) {
    t6 = {
      required: t5
    };
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t1 || $[11] !== t2 || $[12] !== t3 || $[13] !== t4 || $[14] !== t6) {
    t7 = <div className="flex flex-col gap-6"><Form.TemplateTextarea name={t1} label={t2} placeholder={t3} size="compact" autocompleteItems={t4} rules={t6} /></div>;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
};
export default TextBlockForm;
function _temp($) {
  return $.form.content;
}
function _temp2($_0) {
  return $_0.form.contentPlaceholder;
}
function _temp3($_1) {
  return $_1.form.contentRequired;
}